export const catalog = {
  catalogSearchInputPlaceholderTitle: 'Szukaj',
  catalogHeaderTitle: 'Szczegóły',
  catalogDetailsCurtainCopyOptionTitle: 'Skopiuj link',
  catalogDetailsLinkCopiedAlertText: 'Link skopiowany!',
  catalogDetailsCurtainFlagOptionTitle: 'Zgłoś treść',
  catalogDetailsFlagCurtainTitle: 'Zgłoś',
  catalogReportedCurtainContent: 'Treść zgłoszona',
  catalogWantBuy: 'Chcesz kupić {item} od {app}',
  catalogInterestedIn: '{link}'
}
